module.exports = __webpack_public_path__ + "static/23-d3aacffa7adb6078ad2d906174a27178.jpg";